const actions = {
  SET_STATE: 'agentPortal/SET_STATE',
  GET_USER_STATS: 'agentPortal/GET_USER_STATS',
  GET_BUSINESS_STATS: 'agentPortal/GET_BUSINESS_STATS',
  GET_WALLET_STATISTICS: 'agentPortal/GET_WALLET_STATISTICS',
  FETCH_SUB_AGENTS: 'agentPortal/FETCH_SUB_AGENTS',
  CREATE_SUB_AGENT: 'agentPortal/CREATE_SUB_AGENT',
  UPDATE_SUB_AGENT: 'agentPortal/UPDATE_SUB_AGENT',
  FETCH_SALES_AGENT_BY_ID: 'agentPortal/FETCH_SALES_AGENT_BY_ID',
  ASSIGN_MERCHANT_TO_SUB_AGENT: 'agentPortal/ASSIGN_MERCHANT_TO_SUB_AGENT',
  FETCH_AGENT_COMMISSION: 'agentPortal/FETCH_AGENT_COMMISSION',
  FETCH_AGENT_YEARLY_COMMISSION: 'agentPortal/FETCH_AGENT_YEARLY_COMMISSION',
  FETCH_MERCHANT_FEE: 'agentPortal/FETCH_MERCHANT_FEE',
  FETCH_PAYOUT_HISTORY: 'agentPortal/FETCH_PAYOUT_HISTORY',
  REMOVE_MERCHANT_FROM_SUB_AGENT: 'agentPortal/REMOVE_MERCHANT_FROM_SUB_AGENT',
}

export default actions
